module.exports = __webpack_public_path__ + "caac734d4414b68213ad207330cd8be6.svg";